import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateRepeatBooking } from 'repositories/BerthApi/updateRepeatBooking'
import { berthKeys, bookingKeys } from 'repositories/queryKeys'

export function useUpdateRepeatBooking() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateRepeatBooking,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
      // 繰り返しインスタンスは berthId を持つため未割当エリアには現れないが、
      // 他 3 hook と invalidate 範囲を揃えて将来の振る舞い変更に備える
      queryClient.invalidateQueries({ queryKey: bookingKeys.unassigned() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.details() })
    },
  })
}
